const FACEBOOK_MENTION_REGEX = /@\[(\d+)\]\(([^)]+)\)+/g;

export function countFacebookMentions(value?: string | null) {
  if (!value) {
    return 0;
  }

  return [...value.matchAll(FACEBOOK_MENTION_REGEX)].length;
}

export function countMentionsForPlatform({
  value,
  platformType,
}: {
  value?: string | null;
  platformType?: string | null;
}) {
  if (!value) {
    return 0;
  }

  if (platformType === "FB") {
    return countFacebookMentions(value);
  }

  return value.split("@").length - 1;
}
